import React from "react";
import ReactDOM from "react-dom";
import HubspotForm from "react-hubspot-form";

export default function OrderNowModal() {
  return (
    <div
      className="modal fade"
      id="order-now-modal"
      tabIndex="-1"
      role="dialog"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        style={{ maxWidth: "700px" }}
      >
        <div className="modal-content">
          <div className="modal-header pb-0 border-none">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body px-5">
            <h5 className="font-supersized font-weight-bold mb-4">Order Now</h5>
            <HubspotForm
              portalId="6893926"
              formId="d52ddf2b-57d1-48ea-b05f-8316782c617b"
              onSubmit={() => console.log("Submit!")}
              onReady={(form) => console.log("Form ready!")}
              region="na1"
              loading={<p className="body-text-color">Loading...</p>}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

if (document.getElementById("orderNowIslandCompany")) {
  const element = document.getElementById("orderNowIslandCompany");
  const data = Object.assign({}, element.dataset);

  //console.log(data.data);

  ReactDOM.render(
    <OrderNowModal data={JSON.parse(data.data)} />,
    document.getElementById("orderNowIslandCompany")
  );
}



// WEBPACK FOOTER //
// ./resources/js/components/OrderNowModal/index.js